import { render, staticRenderFns } from "./Revenu.vue?vue&type=template&id=1aa86488&scoped=true"
import script from "./Revenu.vue?vue&type=script&lang=js"
export * from "./Revenu.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=1aa86488&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa86488",
  null
  
)

export default component.exports